export default {"src":"/_next/static/media/play-white.f1d147a3.svg","height":40,"width":40};